import { Reducer } from 'redux';

import { ProfileState } from './ProfileState';
import {
  PROFILE_RESET_DATA,
  PROFILE_SET_DATA,
  PROFILE_SET_LOADING,
  PROFILE_SET_VISITS,
  PROFILE_RESET_VISITS,
} from './actions';

const INITIAL_STATE = {
  loading: false,
  data: null,
  visits: {
    start: null,
    intent: null,
    compare: null,
    documents: null,
  },
};

export const StateProfileReducer: Reducer<ProfileState> = (
  state = INITIAL_STATE,
  { type, payload },
) => {
  switch (type) {
    case PROFILE_SET_LOADING:
      return {
        ...state,
        loading: payload.loading,
      };
    case PROFILE_SET_DATA:
      return {
        ...state,
        data: payload.session,
        loading: false,
      };
    case PROFILE_RESET_DATA:
      return {
        ...state,
        data: null,
        loading: false,
      };
    case PROFILE_SET_VISITS:
      return {
        ...state,
        visits: {
          ...state.visits,
          [payload.type]: payload.visits,
        },
      };
    case PROFILE_RESET_VISITS:
      return {
        ...state,
        visits: {
          ...state.visits,
          [payload.type]: null,
        },
      };
    default:
      return state;
  }
};
